import { useEffect, useState } from 'react';

interface ResponseData {
  linkToken: string;
  link_token?: string;
}

interface UsePlaidLinkTokenResponse {
  isLoading: boolean;
  hasError: boolean;
  token: string | null;
  refetchToken: () => void;
}

const usePlaidLinkToken = (apiBasePath: string, businessId: string): UsePlaidLinkTokenResponse => {
  const [token, setToken] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);

  const fetchToken = (): void => {
    fetch(`${apiBasePath}/business/${businessId}/link`, {
      credentials: 'include',
    })
      .then(response => {
        if (response.ok) {
          return response.json() as Promise<ResponseData>;
        }
        throw new Error('Failed to fetch token');
      })
      .then(data => {
        setToken(data.link_token ?? data.linkToken);
      })
      .catch(() => {
        setHasError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect((): void => {
    fetchToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refetchToken = (): void => {
    fetchToken();
  };

  return {
    token,
    isLoading,
    hasError,
    refetchToken,
  };
};

export default usePlaidLinkToken;
